module.exports = __webpack_public_path__ + "img/map-message-6.15f3c536.png";